import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 700 800"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#28B4CD",
      d: "M50 0h424.823l225.175 224.301V750c0 27.625-22.398 50-49.999 50h-600C22.4 800 0 777.625 0 750V50C0 22.376 22.401 0 50 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-opacity": ".15",
      d: "M699.277 224.999H525.001c-27.6 0-49.999-22.399-49.999-50V.499z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M512.45 379.074c8.376 0 12.476-7.299 12.476-14.374 0-7.326-4.276-14.401-12.476-14.401h-47.699c-9.326 0-14.525 7.724-14.525 16.25v117.225c0 10.45 5.949 16.25 13.999 16.25 8.001 0 13.977-5.8 13.977-16.25v-32.175h28.85c8.95 0 13.425-7.325 13.425-14.599 0-7.124-4.475-14.201-13.425-14.201h-28.85v-43.725zm-161.225-28.775h-34.9c-9.476 0-16.201 6.501-16.201 16.149v117.427c0 11.974 9.674 15.724 16.599 15.724h36.626c43.349 0 71.974-28.524 71.974-72.55-.023-46.549-26.972-76.75-74.098-76.75m1.677 120.352h-21.277V379.25h19.176c29.026 0 41.65 19.476 41.65 46.35 0 25.151-12.401 45.051-39.549 45.051M225.051 350.299h-34.575c-9.775 0-15.226 6.449-15.226 16.25v117.225c0 10.45 6.25 16.25 14.649 16.25 8.4 0 14.649-5.8 14.649-16.25v-34.226h21.675c26.749 0 48.825-18.95 48.825-49.425.002-29.823-21.297-49.824-49.997-49.824m-.574 71.752h-19.926v-44.226h19.926c12.3 0 20.125 9.6 20.125 22.125-.026 12.501-7.825 22.101-20.125 22.101"
    }, null, -1)
  ])))
}
export default { render: render }